import { Expose, plainToInstance } from "class-transformer";
import camelcaseKeys from "camelcase-keys";

export class SmsPanelSentSmsStatisticModel {
  @Expose()
  public date?: Date;

  @Expose()
  public dateFa?: string;

  @Expose()
  public count?: number;

  public static toClass(data: object) {
    //@ts-ignore
    return plainToInstance(SmsPanelSentSmsStatisticModel, camelcaseKeys(data, { deep: true }), { excludeExtraneousValues: true });
  }

  public static toArrayOfClass(data: object[]) {
    //@ts-ignore
    return plainToInstance(SmsPanelSentSmsStatisticModel, camelcaseKeys(data, { deep: true }) as SmsPanelSentSmsStatisticModel[], { excludeExtraneousValues: true });
  }
}
